'use strict';

Object.defineProperty(exports, "__esModule", {
				value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
				(function (Modal, $) {
								'use strict';

								/**
          *
          *   <div class="overlay" data-overlay></div> in theme.liquid
          *
          */

								var $dom = {};

								var cacheDom = function cacheDom() {
												$dom.body = $('body');
												$dom.modal = $('[data-modal]');
												$dom.modalShow = $('[data-modal-show]');
												$dom.modalHide = $('[data-modal-hide]');
								};

								Modal.show = function (modalName) {
												window.Scroll.lock();
												$dom.body.attr('data-active-modal', modalName);
												var target = $('[data-modal="' + modalName + '"]');
												target.fadeIn(300, function () {
																target.addClass('modal--active');
												});
												$(document).trigger('MODAL_SHOW', { name: modalName });
								};

								Modal.hide = function () {
												window.Scroll.unlock();
												$dom.body.removeAttr('data-active-modal');
												$dom.modal.removeClass('modal--active');
												return $dom.modal.fadeOut(300);
								};

								var bindUIActions = function bindUIActions() {
												$dom.modalShow.on('click', function (event) {
																event.preventDefault();
																window.Modal.show($(this).attr('data-modal-show'));
												});
												$dom.modalHide.on('click', function (event) {
																event.preventDefault();
																window.Modal.hide();
												});
								};

								Modal.init = function () {
												cacheDom();
												bindUIActions();
								};
				})(window.Modal = window.Modal || {}, _jquery2.default);
};